export function ensureNumber(input: number|string):number {
    return typeof input === 'number' ? input : parseFloat(input);
}

/*
export function isNumber(input:any) {
    return isNaN(input);
}
*/
export function isNumeric(str) {
    return !isNaN(str) && !isNaN(parseFloat(str));
}

export function formatNumber(input: number|string, decimal: number = 0) {
    return ensureNumber(input).toLocaleString(
        undefined,
        { minimumFractionDigits: decimal }
    );
}

export function abbreviateNumber(input: number) {
    return Intl.NumberFormat(undefined/*'en-US'*/, {
        notation: "compact",
        maximumFractionDigits: 1
    }).format(input);
}

export function formatCurrency(input: number) {
    return Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    }).format(input);
}
